import { gql } from "apollo-boost";
import { ShippingOptionFragment } from "../fragments";

export const GET_SHIPPING_OPTIONS = gql`
    query shippingOptions {
        shippingOptions {
            ...ShippingOptionFragment
        }
    }
    ${ShippingOptionFragment}
`;

export const GET_PRODUCT_BASE_SHIPPING_OPTION_BY_ORDER = gql`
    query getProductBaseShippingOptionByOrder($id: ID!) {
        getProductBaseShippingOptionByOrder(id: $id) {
            ...ShippingOptionFragment
        }
    }
    ${ShippingOptionFragment}
`;

